import { render, staticRenderFns } from "./PainPoints.vue?vue&type=template&id=291c07d4&scoped=true&"
import script from "./PainPoints.vue?vue&type=script&lang=js&"
export * from "./PainPoints.vue?vue&type=script&lang=js&"
import style0 from "./PainPoints.vue?vue&type=style&index=0&id=291c07d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291c07d4",
  null
  
)

export default component.exports